// extracted by mini-css-extract-plugin
export default {"root":"WarehouseRelationshipCard_root__yECWf","displayHeader":"WarehouseRelationshipCard_displayHeader__iZFp2"};